<section class="bg-warning">
  <footer class="container pt-4">
    <div class="row">
      <div class="col-12 col-lg">
        <a
          routerLink="/home"
          class="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto"
        >
          <img src="assets/images/dfs-ins-logo-light.svg" alt="DFS Insurance" />
        </a>
      </div>
      <div class="col-6 col-lg">
        <h4 class="text-light">Company</h4>
        <ul class="list-unstyled text-small">
          <li>
            <a class="link-light" routerLink="/irrigation-insurance"
              >Irrigation Insurance</a
            >
          </li>
          <li>
            <a class="link-light" routerLink="/about">About DFS Insurance</a>
          </li>
          <li>
            <a
              class="link-light"
              href="https://www.fnbo.com/careers"
              target="_blank"
              >Careers</a
            >
          </li>
          <li><a class="link-light" routerLink="/contact">Contact Us</a></li>
        </ul>
      </div>
      <div class="col-6 col-lg">
        <h4 class="text-light">Resources</h4>
        <ul class="list-unstyled text-small">
          <li><a class="link-light" routerLink="/get-quote">Get a Quote</a></li>
          <li>
            <a
              class="link-light"
              href="javascript:void(0)"
              (click)="downloadClaimPacket()"
              >Start a Claim</a
            >
          </li>
          <li *ngIf="enableCustomerPortal">
            <a class="link-light" routerLink="/register-customer"
              >Customer Registration</a
            >
          </li>
          <li><a class="link-light" routerLink="/forms">Forms</a></li>
          <li>
            <a class="link-light" routerLink="/register">Agent Registration</a>
          </li>
          <li><a class="link-light" routerLink="/login">Agent Login</a></li>
        </ul>
      </div>
      <div class="col-6 col-lg">
        <h4 class="text-light">Contact Us</h4>
        <p class="text-small text-light">
          14010 FNB Parkway Suite 400<br />
          Omaha, NE 68154<br />
          P: 800.444.3584
        </p>
      </div>
    </div>
    <div class="row pt-4">
      <p class="text-small text-light">
        DFS Insurance operates through, Diversified Agrisurance Company, for the
        purpose of selling insurance products.<br />
        Diversified Agrisurance Company is a licensed insurance producer (d/b/a
        Diversified Agrisurance Insurance Agency in California, CA Lic. No.
        0E67704).<br />
        Diversified Agrisurance Company is located at 14010 FNB Parkway, #400,
        Omaha, NE 68145 (NPN: 2826138).<br />
        Diversified Agrisurance Company is doing business as DFS Insurance Group
        in MI
      </p>
    </div>
    <div class="d-flex justify-content-between pt-4 mt-4 border-top text-light">
      <p>
        &copy; {{ currentYear }} - DFS Insurance 1.800.444.3584. All rights
        reserved |
        <a
          class="text-light text-decoration-underline"
          href="javascript:void(0)"
          (click)="downloadPrivacyPolicy()"
          >Privacy Policy</a
        >
        |
        <a
          class="text-light text-decoration-underline"
          href="javascript:void(0)"
          (click)="downloadTermsOfUse()"
          >Terms of Use</a
        >
      </p>
      <ul class="list-unstyled d-flex">
        <li class="ms-3">
          <a
            class="link-light"
            href="https://twitter.com/DivFinancial"
            aria-label="DFS Insurance Twitter"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-twitter"
              viewBox="0 0 16 16"
              role="img"
            >
              <path
                d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"
              />
            </svg>
          </a>
        </li>
        <li class="ms-3">
          <a
            class="link-light"
            href="https://www.facebook.com/divfinancial"
            aria-label="DFS Insurance Facebook"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-facebook"
              viewBox="0 0 16 16"
              role="img"
            >
              <path
                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
              />
            </svg>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</section>
